import {
  ActionIcon,
  Badge,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  Group,
  Menu,
  Select,
  SelectProps,
  Text,
  TextInput,
  Tooltip,
} from "@mantine/core";
import {
  IconBrandBootstrap,
  IconCheck,
  IconDownload,
  IconEye,
  IconReceipt,
  IconSearch,
  IconTimeDuration15,
  IconUser,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_SortingState,
  useMantineReactTable,
} from "mantine-react-table";
import * as React from "react";
import { useEffect, useState } from "react";

import { DatePickerInput } from "@mantine/dates";
import { useIsFirstRender, useMediaQuery } from "@mantine/hooks";
import { useNavigate } from "react-router-dom";
// Using local `HandoverSlipModel` for this list view
import { useForm } from "@mantine/form";
import moment from "moment";
import {
  keySearchRequestListReceipts,
  repositoryMdm,
  repositoryPos,
  styleTableMantine,
} from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { SelectListItemBase } from "../../../_base/model/_base/SelectListItemBase";
import { formatDateTransfer } from "../../../common/FormatDate/FormatDate";
import useWindowSize from "../../../common/WindownSize/WindownSize";
import { _localization } from "../../../config/location";
import { green } from "../../../const/variables";
import { SelectListItem } from "../../../model/SelectListItem";
import { MessageResponse } from "../RetailOrder/ModalComponent/UIGiftPromotion";
import { BASE_API_POS } from "../../../config";

interface DocumentInfo {
  id: number;
  code: string;
  originalDocuments: string;
  originalDocumentNumber: string;
  codeForFees: string;
  occurringCredit: string;
  debtObjectCode: string;
  debtObjectName: string;
  employeeFund: string;
  branchesFund: string;
  description: string;
  departmentFund: string;
  fee: string;
  contract: string;
  stt: number;
  orderNumber: string;
  attribute2: string;
  attribute7: string;
  amountTotal: number;
  amountPaid: number;
  amountRemaining: number;
  allocatedAmount: number;
  note: string;
  codeBranch: string;
}

interface DepartmentUser {
  departmentId: number;
  name: string;
  description: string | null;
  active: boolean;
  departmentCode: string;
  creationDate: string;
  createdBy: string;
  lastUpdateDate: string | null;
  lastUpdatedBy: string | null;
  address: string;
  branchId: number;
}

interface AddressInfo {
  active: boolean;
  address: string;
  birthOfDate: string;
  code: string;
  buyerName: string;
  commune: number;
  companyName: string | null;
  contact: string | null;
  country: string | null;
  debtLimit: number | null;
  description: string | null;
  district: number;
  email: string;
  fax: string | null;
  groupId: number;
  groupName: string;
  id: number;
  name: string;
  province: number;
  sex: number;
  taxCode: string | null;
  tblDmCustomerGroupModel: any | null;
  telephoneNumber: string;
  type: number;
}

// New simplified interface for TblBienBan (Handover Slip)
interface HandoverSlipModel {
  id: number;
  maBienBan: string;
  nguoiNopTien: number | null;
  nguoiNhanTien: number | null;
  maChiNhanh: number | null;
  tongTien: number | null;
  createdAt: string | null;
  createdBy: number | null;
  lastUpdatedAt: string | null;
  lastUpdatedBy: number | null;
}

const HandoverSlipList = () => {
  const navigate = useNavigate();
  //#region  table
  //data and fetching state
  const [data, setData] = useState<HandoverSlipModel[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [dataBranch, setDataBranch] = useState<SelectListItem[]>([]);
  const [dataWarehouse, setDataWarehouse] = useState<SelectListItemBase[]>([]);

  const handleViewDetail = (maBienBan: string) => {
    navigate("/bill/handover-slip-detail", {
      state: { maBienBan },
    });
  };

  const checkedPinSearch = localStorage.getItem("checkedPinSearch") === "true";

  const [loading, setLoading] = useState<boolean>(false);
  const [skip, setSkip] = useState<number>(1);
  const [searchTerm, setSearchTerm] = useState<string>("");
  //table state
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    []
  );
  // const [typeKey, settypeKey] = useState<number | null>(null);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [height, setHeight] = useState(0);

  const debounceTimeoutRef = React.useRef<number | null>(null);
  const firstRender = useIsFirstRender();

  const sizeGrid = { base: 6, sm: 6, md: 4, lg: 4, xl: 2 };

  // const searchRef = React.useRef(search);
  const _searchJson = localStorage.getItem(keySearchRequestListReceipts)
    ? JSON.parse(localStorage.getItem(keySearchRequestListReceipts) ?? "")
    : null;

  const innitStateSearch = React.useMemo(
    () => ({
      // Filters aligned with TblBienBan API
      MaBienBan:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.MaBienBan as string)
          : "",
      NguoiNopTien:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.NguoiNopTien as number | null)
          : null,
      NguoiNhanTien:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.NguoiNhanTien as number | null)
          : null,
      MaChiNhanh:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.MaChiNhanh as number | null)
          : null,
      FromDate:
        firstRender && _searchJson && checkedPinSearch && _searchJson.FromDate
          ? new Date(_searchJson.FromDate)
          : null,
      ToDate:
        firstRender && _searchJson && checkedPinSearch && _searchJson.ToDate
          ? new Date(_searchJson.ToDate)
          : null,
      KeySearch:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.KeySearch as string)
          : "",
      Skip: 0,
      Take: pagination.pageSize,
    }),
    [firstRender, _searchJson]
  );

  const form = useForm({
    mode: "uncontrolled",
    initialValues: innitStateSearch,
  });

  let sortingQuery = "";
  if (sorting && sorting.length > 0) {
    const { id, desc } = sorting[0] || {};
    if (id) {
      sortingQuery = `&sort=${encodeURIComponent(id)}&isOrder=${desc}`;
    }
  }

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);

    try {
      const values = form.getValues();
      const skipVal = pagination.pageIndex * pagination.pageSize;
      const takeVal = pagination.pageSize;

      const params: Record<string, any> = {
        Skip: skipVal,
        Take: takeVal,
      };

      if (values.MaBienBan) params.MaBienBan = values.MaBienBan;
      if (values.NguoiNopTien) params.NguoiNopTien = values.NguoiNopTien;
      if (values.NguoiNhanTien) params.NguoiNhanTien = values.NguoiNhanTien;
      if (values.MaChiNhanh) params.MaChiNhanh = values.MaChiNhanh;
      if (values.KeySearch) params.KeySearch = values.KeySearch;

      if (values.FromDate) {
        const d =
          values.FromDate instanceof Date
            ? values.FromDate
            : new Date(values.FromDate);
        params.FromDate = moment(d).toISOString();
      }
      if (values.ToDate) {
        const d =
          values.ToDate instanceof Date
            ? values.ToDate
            : new Date(values.ToDate);
        params.ToDate = moment(d).toISOString();
      }

      const query = Object.entries(params)
        .map(
          ([k, v]) =>
            `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`
        )
        .join("&");

      const url = `/api/v1/TblBienBan/get-list?${query}`;
      const response = await repositoryPos.get<any>(url);

      if (response && response.success) {
        // support multiple response shapes
        const payload = response.data ?? response;
        let list: any[] = [];
        let count = 0;

        if (Array.isArray(payload)) {
          list = payload;
          count = payload.length;
        } else if (Array.isArray(payload.data)) {
          list = payload.data;
          count = payload.count ?? list.length;
        } else if (Array.isArray(payload.lists)) {
          list = payload.lists;
          count = payload.count ?? list.length;
        }

        setData(list);
        setRowCount(count);
        table.resetRowSelection?.();
      } else {
        setData([]);
        setRowCount(0);
      }
    } catch (error) {
      setIsError(true);
      console.error(error);
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };

  const handleExport = async () => {
    try {
      const values = form.getValues();

      const params: Record<string, any> = {};

      if (values.MaBienBan) params.MaBienBan = values.MaBienBan;
      if (values.NguoiNopTien) params.NguoiNopTien = values.NguoiNopTien;
      if (values.NguoiNhanTien) params.NguoiNhanTien = values.NguoiNhanTien;
      if (values.MaChiNhanh) params.MaChiNhanh = values.MaChiNhanh;
      if (values.KeySearch) params.KeySearch = values.KeySearch;

      if (values.FromDate) {
        const d =
          values.FromDate instanceof Date
            ? values.FromDate
            : new Date(values.FromDate);
        params.FromDate = moment(d).toISOString();
      }
      if (values.ToDate) {
        const d =
          values.ToDate instanceof Date
            ? values.ToDate
            : new Date(values.ToDate);
        params.ToDate = moment(d).toISOString();
      }

      let sortingQuery = "";
      if (sorting && sorting.length > 0) {
        const { id, desc } = sorting[0] || {};
        if (id) {
          sortingQuery = `&sort=${encodeURIComponent(id)}&isOrder=${desc}`;
        }
      }

      const query = Object.entries(params)
        .map(
          ([k, v]) =>
            `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`
        )
        .join("&");

      const url = `/api/v1/TblBienBan/export-bien-ban${
        query ? `?${query}` : ""
      }${sortingQuery}`;
      const _url = BASE_API_POS + url;
      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/vnd.ms-excel",
          Authorization: `Bearer ${token?.replace(/"/g, "")}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to download file");
      }

      const blob = await response.blob();
      const urlss = window.URL.createObjectURL(blob);
      const _name = new Date().toISOString().slice(0, 10);
      let filename = "bao_cao_bien_ban_ban_giao_" + _name + ".xlsx";
      const link = document.createElement("a");
      link.href = urlss;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(urlss);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };
  // Hàm gọi API chi nhánh
  const fetchDataBranch = async () => {
    const dataApi = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblDmInventory/get-select-branch"
    );

    if (dataApi && dataApi.success) {
      const filteredData = dataApi.data.slice(1);
      setDataBranch(filteredData);
    }
  };

  const fetchDataWarehouse = async () => {
    const dataApi = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblDmEmployee/get-select"
    );

    if (dataApi && dataApi.success) {
      setDataWarehouse(dataApi.data);
    }
  };

  const fetchDataGetAll = async () => {
    try {
      const response = await repositoryPos.get<
        MessageResponse<DepartmentUser[]>
      >(`/api/v1/TblDepartment/get-all`);

      if (response && response.success) {
        const result = response.data;
      } else {
        console.error("Failed to fetch departmentFund details");
      }
    } catch (error) {
      console.error("Error fetching departmentFund details", error);
    }
  };

  const isSmallScreen = useMediaQuery("(max-width: 900px)");
  const [columnPinning, setColumnPinning] = useState<boolean | undefined>(true);

  useEffect(() => {
    if (isSmallScreen) {
      setColumnPinning(false);
    } else {
      setColumnPinning(true);
    }
  }, [isSmallScreen]);

  useEffect(() => {
    fetchDataGetAll();
    fetchDataWarehouse();
  }, []);

  // Helper functions to map IDs to names
  const getEmployeeName = (employeeId: number | null): string => {
    if (!employeeId) return "";
    const employee = dataWarehouse.find(
      (item) => String(item.value) === String(employeeId)
    );
    return employee
      ? `${employee.att1} - ${employee.text}`
      : String(employeeId);
  };

  const getBranchName = (branchId: number | null): string => {
    if (!branchId) return "";
    const branch = dataBranch.find(
      (item) => String(item.value) === String(branchId)
    );
    return branch?.text ?? String(branchId);
  };

  const columns = React.useMemo<MRT_ColumnDef<HandoverSlipModel>[]>(
    () => [
      {
        header: "STT",
        accessorKey: "STT",
        enableColumnActions: false,
        enableSorting: false,
        enableResizing: false,
        Cell: ({ row }) => <>{row?.index + 1}</>,
        size: 60,
      },
      {
        accessorKey: "maBienBan",
        enableColumnActions: false,
        header: "Mã phiếu bàn giao",
        size: 250,
        Cell: ({ renderedCellValue }) => (
          <Tooltip label="Xem chi tiết">
            <Badge radius="sm" variant="dot" size="lg" color={green.base}>
              {renderedCellValue}
            </Badge>
          </Tooltip>
        ),
      },
      {
        accessorKey: "createdAt",
        header: "Thời gian tạo",
        enableColumnActions: false,
        size: 220,
        Cell: ({ renderedCellValue }: any) => (
          <>{formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "nguoiNopTien",
        header: "Người nộp tiền",
        enableColumnActions: false,
        size: 250,
        Cell: ({ row }) => (
          <Text size="md">{getEmployeeName(row.original.nguoiNopTien)}</Text>
        ),
      },
      {
        accessorKey: "nguoiNhanTien",
        header: "Người nhận tiền",
        enableColumnActions: false,
        size: 250,
        Cell: ({ row }) => (
          <Text size="md">{getEmployeeName(row.original.nguoiNhanTien)}</Text>
        ),
      },
      {
        accessorKey: "maChiNhanh",
        header: "Chi nhánh",
        enableColumnActions: false,
        size: 250,
        Cell: ({ row }) => (
          <Text size="md">{getBranchName(row.original.maChiNhanh)}</Text>
        ),
      },
      {
        accessorKey: "tongTien",
        header: "Tổng tiền",
        enableColumnActions: false,
        size: 200,
        Cell: ({ renderedCellValue }) => (
          <Text fw={600}>
            {new Intl.NumberFormat("vi-VN").format(
              Number(renderedCellValue ?? 0)
            )}
          </Text>
        ),
      },
      {
        accessorKey: "actions",
        header: "Thao tác",
        enableColumnActions: false,
        size: 160,
        Cell: ({ renderedCellValue, row }) => (
          <Flex gap={10}>
            <Tooltip label="Xem chi tiết">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="blue"
                onClick={() => handleViewDetail(row.original.maBienBan)}
              >
                <IconEye size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
          </Flex>
        ),
      },
    ],
    [dataWarehouse, dataBranch]
  );

  const table = useMantineReactTable<HandoverSlipModel>({
    columns,
    data,
    enableColumnResizing: true,
    positionToolbarAlertBanner: "bottom",
    //add custom action buttons to top-left of top toolbar
    renderTopToolbarCustomActions: ({ table }) => <></>,
    enableStickyHeader: true,
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    localization: _localization,
    enableRowSelection: false,
    // getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["STT", "receiptNumber", "mrt-row-select"],
        right: ["totalAmount", "actions"],
      },
      columnVisibility: { id: false },
      density: "md",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    mantineTableProps: {
      striped: false,
    },
    onRowSelectionChange: setRowSelection,
    manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    rowCount,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      sorting,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "md",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: columnPinning,
  });

  const fetchDataCustomer = async (searchTerm: string) => {
    setLoading(true);
    const query = searchTerm ? `KeySearch=${searchTerm}&` : "";
    const dataApi = await repositoryPos.get<MessageResponse<any>>(
      `/api/v1/TblDmCustomer/get-select?${query}Skip=${1}&Take=${30}`
    );

    if (dataApi && dataApi.success) {
      const filteredData = dataApi.data.filter(
        (item: any) => item.text !== null
      );
      setSkip((prevSkip) => prevSkip + 1);
    }
    setLoading(false);
  };

  const debouncedFetchDataCustomer = React.useCallback((value: string) => {
    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }
    debounceTimeoutRef.current = window.setTimeout(() => {
      fetchDataCustomer(value);
    }, 250);
  }, []);

  const fetchDataBranchs = async () => {
    const response = await repositoryPos.get<
      MessageResponse<SelectListItemBase[]>
    >("/api/v1/TblDmInventory/get-select-branch?auth=false");

    if (response && response.success) {
      let result = response.data;
      //   setDataBranchs(result);
    }
  };

  const fetchDataTblDmCustomer = async () => {
    const response = await repositoryPos.get<MessageResponse<AddressInfo[]>>(
      "/api/v1/TblDmCustomer/get-list?Skip=0&Take=50"
    );

    if (response && response.success) {
      let result = response.data;
      //   setAddressInfo(result);
    }
  };

  useEffect(() => {
    fetchDataCustomer("");
    fetchDataBranchs();
    fetchDataTblDmCustomer();
    fetchDataBranch();
    fetchDataWarehouse();
  }, []);

  useEffect(() => {
    debouncedFetchDataCustomer(searchTerm);
  }, [searchTerm, debouncedFetchDataCustomer]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (150 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);

  useEffect(() => {
    if (pagination.pageIndex === 0 && data.length < pagination.pageSize) {
      fetchData();
    } else {
      fetchData();
    }
  }, [pagination.pageIndex, pagination.pageSize, sorting]);

  return (
    <>
      <div
        style={{
          border: "1px solid #dee2e6",
          padding: "10px",
          position: "relative",
        }}
        ref={headerRef}
      >
        <Group gap={0} justify="space-between">
          <_breadcrumb></_breadcrumb>
          <Button
            leftSection={<IconDownload size={14} />}
            color="violet"
            variant="outline"
            onClick={handleExport}
          >
            Xuất Excel
          </Button>
        </Group>
        <Grid mt={10}>
          <Grid.Col span={{ base: 12, md: 12, lg: 12 }}>
            <Grid>
              <Grid.Col span={sizeGrid}>
                <TextInput
                  key={form.key("KeySearch")}
                  placeholder="Từ khoá"
                  leftSection={<IconSearch color="#15aabf" />}
                  {...form.getInputProps("KeySearch")}
                />
              </Grid.Col>
              <Grid.Col span={sizeGrid}>
                <TextInput
                  key={form.key("MaBienBan")}
                  placeholder="Mã phiếu"
                  leftSection={<IconReceipt color="#15aabf" />}
                  {...form.getInputProps("MaBienBan")}
                />
              </Grid.Col>
              <Grid.Col span={sizeGrid}>
                <DatePickerInput
                  type="default"
                  key={form.key("FromDate")}
                  leftSection={<IconTimeDuration15 color="#15aabf" />}
                  size="md"
                  placeholder="Từ ngày"
                  locale="vi"
                  valueFormat="DD/MM/YYYY"
                  clearable
                  {...form.getInputProps("FromDate")}
                />
              </Grid.Col>
              <Grid.Col span={sizeGrid}>
                <DatePickerInput
                  key={form.key("ToDate")}
                  leftSection={<IconTimeDuration15 color="#15aabf" />}
                  size="md"
                  placeholder="Đến ngày"
                  locale="vi"
                  valueFormat="DD/MM/YYYY"
                  clearable
                  {...form.getInputProps("ToDate")}
                />
              </Grid.Col>
              <Grid.Col span={sizeGrid}>
                <Select
                  key={dataWarehouse.length || form.key("NguoiNopTien")}
                  searchable
                  clearable
                  placeholder="Người nộp tiền"
                  leftSection={<IconUser color="#15aabf" />}
                  comboboxProps={{
                    transitionProps: { transition: "pop", duration: 200 },
                  }}
                  limit={50}
                  data={dataWarehouse.map((item) => {
                    return {
                      label: item.att1 + " - " + item.text,
                      value: String(item.value ?? ""),
                    };
                  })}
                  {...form.getInputProps("NguoiNopTien")}
                />
              </Grid.Col>
              <Grid.Col span={sizeGrid}>
                <Select
                  key={dataWarehouse.length || form.key("NguoiNhanTien")}
                  searchable
                  clearable
                  placeholder="Người nhận tiền"
                  leftSection={<IconUser color="#15aabf" />}
                  comboboxProps={{
                    transitionProps: { transition: "pop", duration: 200 },
                  }}
                  limit={50}
                  data={dataWarehouse.map((item) => {
                    return {
                      label: item.att1 + " - " + item.text,
                      value: String(item.value ?? ""),
                    };
                  })}
                  {...form.getInputProps("NguoiNhanTien")}
                />
              </Grid.Col>
              <Grid.Col span={sizeGrid}>
                <Select
                  key={dataBranch.length || form.key("MaChiNhanh")}
                  searchable
                  clearable
                  placeholder="Chi nhánh"
                  comboboxProps={{
                    transitionProps: { transition: "pop", duration: 200 },
                  }}
                  limit={50}
                  leftSection={<IconBrandBootstrap color="#15aabf" />}
                  data={dataBranch.map((item) => {
                    return {
                      label: item.text ?? "",
                      value: String(item.value ?? ""),
                    };
                  })}
                  {...form.getInputProps("MaChiNhanh")}
                />
              </Grid.Col>
              <Grid.Col span={sizeGrid}>
                <Button
                  leftSection={<IconSearch size={14} />}
                  color="blue"
                  variant="outline"
                  onClick={async () => {
                    await fetchData();
                    localStorage.setItem(
                      keySearchRequestListReceipts,
                      JSON.stringify(form.getValues())
                    );
                  }}
                >
                  Tìm kiếm
                </Button>
              </Grid.Col>
            </Grid>
          </Grid.Col>
        </Grid>
      </div>
      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </>
  );
};
export default HandoverSlipList;
